import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Attachments from '@/components/Attachment';
export const BaseAttachment = ({
  error,
  label,
  name,
  control,
  defaultValue,
  accept,
  required,
  disabled
}) => {
  return (
    <div className="">
      <label
        htmlFor={name}
        className="text-slate-600 text-sm capitalize leading-tight tracking-normal">
        {label}
      </label>
      {required && (
        <label
          htmlFor={name}
          className="text-red-600 mx-2 text-xs capitalize  leading-tight tracking-normal">
          الحقل مطلوب *
        </label>
      )}
      <div className="my-1  rounded-xl border border-gray-200">
        <Controller
          name={name}
          defaultValue={defaultValue}
          control={control}
          render={({ field: { onChange, value } }) => (
            <Attachments
              disabled={disabled}
              onComplete={onChange}
              value={value}
              name={name}
              accept={accept}
            />
          )}
        />
      </div>

      {error && <span className="text-red-500 text-xs">{error.message}</span>}
    </div>
  );
};

BaseAttachment.propTypes = {
  error: PropTypes.object,
  control: PropTypes.any,
  label: PropTypes.string,
  options: PropTypes.array,
  validation: PropTypes.object,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  multi: PropTypes.bool,
  defaultValue: PropTypes.any
};
BaseAttachment.defaultProps = {
  multi: false,
  accept: '',
  required: false
};
